import { Component, ViewContainerRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RightPanelComponent } from "../../right-panel/right-panel.component";
import { ModalComponent } from "../../modal/modal.component";
import { AdvancedFilterComponent } from "../../advanced-filter/advanced-filter.component";
import { TableListRequest } from "../../../models/table-list-request.interface";
import { FileUploadComponent } from "../../file-upload/file-upload.component";
import { ManageEquipmentComponent } from './manage-equipment/manage-equipment.component';
import { EditableTableComponent } from "../../editable-table/editable-table.component";
import { DatePipe, NgClass, NgForOf, NgIf } from "@angular/common";
import { HighlightPipe } from "../../../pipes/highlight.pipe";
import { NoDataComponent } from "../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../no-data-found/no-data-found.component";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";
import { TableMenuComponent } from "../../table-menu/table-menu.component";
import { PaginatedListDataResponse } from "../../../models/paginated-list-data-response";
import { LoadingService } from "../../../services/loading.service";
import { User } from "../../../models/user.interface";
import { MasterService } from "../../../services/masters-service";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { ToasterService } from "../../../services/toaster.service";
import { TableMenuOption, TableMeta } from "../../../models/table-meta.interface";
import { TosTableComponent } from "../../tos-table/tos-table.component";
import { StatsData } from "../../../models/stats-response.interface";
import equipmentMasterMetaConfig from './config/equipmentMasterMeta.json';

@Component({
  selector: 'app-equipment-master',
  standalone: true,
  imports: [FormsModule,
    EditableTableComponent,
    DatePipe,
    HighlightPipe,
    NgForOf,
    NgIf,
    NoDataComponent,
    NoDataFoundComponent,
    ResizableModule,
    SvgIconComponent,
    TableMenuComponent,
    NgClass, TosTableComponent],
  templateUrl: './equipment-master.component.html',
  styleUrl: './equipment-master.component.scss'
})
export class EquipmentMasterComponent {
protected readonly equipmentMasterMetaConfig = equipmentMasterMetaConfig;
filterFields = [
    {
      displayName: 'Number',
      key: 'name',
    }
  ];
  isFilterApplied: boolean = false;
  searchTerm: any;
  focusSearch!: boolean;
  tableLoaded: boolean = false;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: []
  };
  tableMeta!: TableMeta;
  tableStats: StatsData = {
      total: 0,
      active: 0,
      inactive: 0,
  };
  sortColumn: string = "modifiedDate";
  openMenuIndex: number | null = null;
  menuOptions: TableMenuOption[] = [
    { label: 'Edit', value: 'edit' },
    { label: 'Mark as active', value: 'active', condition: (record) => !record.active },
    { label: 'Mark as inactive', value: 'inactive', condition: (record) => record.active },
  ];
  totalTablePages: number = 0;
  currentTablePage: number = 1;
  sortDirection: "asc" | "desc" = "desc";
  rowsPerPage: number = 25;
  currentPage: number = 0;
  tableListRequest: TableListRequest = {
    selectFields: [
      "id",
      "name",
      "description",
      "active",
      "modifiedDate",
      "modifiedBy"
    ],
    orderBy: {
      [this.sortColumn]: this.sortDirection
    },
    limit: this.rowsPerPage,
    includeTotal :true,
    page: this.currentPage
  };
  allTableRecordsSelected: boolean = false;
  selectedItems: any[] = [];
  previousTerm: string = "";

  constructor(private viewContainerRef: ViewContainerRef,
              private loadingService: LoadingService,
              private masterService: MasterService,
              private toasterService: ToasterService) {
  }

  ngOnInit(){
    this.tableMeta = equipmentMasterMetaConfig.equipmentMasterTableConfig;

    this.fetchAllRecords()
  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.masterService.getEquipmentList(this.tableListRequest).subscribe({
      next: (res: any) => {
        this.tableListData = res.data;
        this.calculateTotalPages();
        this.tableLoaded = true;
        this.loadingService.hide()

      },
      error: (error: Error) => {
        console.error("Error occurred:", error);
        this.tableLoaded = false;
        this.loadingService.hide()
      }
    });
  }

  addEquipment() {
    const rightPanelRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelRef.instance.title = "Add Equipment";
    const manageEquipmentRef = rightPanelRef.instance.loadComponent(ManageEquipmentComponent);
    manageEquipmentRef.instance.onSuccessfulSave.subscribe(() => {
      this.fetchAllRecords();
      rightPanelRef.destroy();
    });
    rightPanelRef.instance.close.subscribe((res: any) => {
      if (res && res.refresh) {
        this.refreshTableList();
      }
      rightPanelRef.destroy();
    });
  }

  editEquipment(equipmentId: String) {
    const rightPanelRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelRef.instance.title = "Edit Equipment";
    const manageEquipmentRef = rightPanelRef.instance.loadComponent(ManageEquipmentComponent);
    manageEquipmentRef.instance.onSuccessfulSave.subscribe(() => {
      this.fetchAllRecords();
      rightPanelRef.destroy();
    });
    manageEquipmentRef.setInput("equipmentId", equipmentId);
    rightPanelRef.instance.close.subscribe((res: any) => {
      if (res && res.refresh) {
        this.refreshTableList();
      }
      rightPanelRef.destroy();
    });
  }



  private clearSelection() {
    this.selectedItems = [];
  }

  private refreshTableList() {
    this.fetchAllRecords()
  }



  isAllRecordsOfCurrentPageSelected() {
    return (
      this.allTableRecordsSelected ||
      (this.tableListData.records?.length > 0 &&
        this.tableListData.records?.every((item: User) =>
          this.isSelected(item)
        ))
    );

  }



  isSelected(item: any) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  toggleSelection(item: any) {
    if (!this.isSelected(item)) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  handleMenuToggle(i: number) {
    this.openMenuIndex = this.openMenuIndex === i ? null : i;
  }

  handleOptionSelected(event:any) {
    // record: any, actionName: any
    const { record: record, actionName } = event;
    const recordId = record.id;
    if (actionName === 'edit') {
      this.editEquipment(recordId);
    } else {
        let actionTitle = 'Confirmation';
        let message = 'Are you sure ?';
        let successMsg = 'Done !';
        let flag = false;
        switch (actionName) {
          case 'active':
          case 'inactive':
            if (actionName === 'active') {
              flag = true;
            }
            actionTitle = `${flag ? 'Activate' : 'Inactivate'} Equipment`;
            message = `Are you sure to ${flag ? 'activate' : 'inactivate'} ${record.name
            } ?`;
            successMsg = `Successfully ${flag ? 'activated' : 'inactived'} ${record.name
            } !`;
            break;

          default:
            console.error('unknown actionName');
            break;
        }
        const modalRef = this.viewContainerRef.createComponent(ModalComponent);
        modalRef.instance.title = actionTitle;
        const confirmDialogRef = modalRef.instance.loadComponent(
          ConfirmDialogComponent
        );
        confirmDialogRef.instance.message = message;
        confirmDialogRef.instance.confirm.subscribe(() => {
          this.menuAction(actionName, successMsg, flag, recordId!);
          modalRef.destroy();
        });
        confirmDialogRef.instance.cancel.subscribe(() => {
          modalRef.destroy();
        });
        modalRef.instance.close.subscribe(() => modalRef.destroy());
      }
  }

  menuAction(
    actionName: string,
    successMsg: string,
    flag: boolean,
    userId: string
  ) {
    switch (actionName) {
      case 'active':
      case 'inactive':
        this.masterService.setEquipmentStatus(flag, [userId]).subscribe({
          next: () => {
            this.toasterService.success(successMsg);
            this.refreshTableList();
          },
          error: (err) => {
            console.error(err);
            this.toasterService.error(err.error.errorDesc || 'Unknown Error !');
          },
        });
        break;
      default:
        console.error('unknown actionName');
        break;
    }
  }


  calculateTotalPages() {
      this.totalTablePages = Math.ceil(
        (this.tableListData?.totalCount || 50) / this.rowsPerPage
      );
  }


}
